import React from 'react';
import { Alert, styled, AlertProps } from '@mui/material';
import theme from '../theme';
import SuccessCheckmark from './icon/success-checkmark';

export type NotificationProps = AlertProps & {
  variant: 'filled' | 'standard' | 'outlined' | undefined;
  severity: 'error' | 'warning' | 'info' | 'success' | undefined;
  children: React.ReactNode;
};

const StyledAlert = styled(Alert)(({ variant }) => ({
  backgroundColor: variant === 'filled' ? 'inherit' : 'transparent',
  fontFamily: theme.typography.body2.fontFamily,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.body2.fontWeight,
  lineHeight: theme.typography.body2.lineHeight,
}));

const Notification: React.FC<NotificationProps> = ({
  variant,
  severity,
  children,
  ...props
}) => (
  <>
    {severity === 'error' && (
      <StyledAlert variant={variant} severity="error" {...props}>
        {children}
      </StyledAlert>
    )}
    {severity === 'warning' && (
      <StyledAlert variant={variant} severity="warning" {...props}>
        {children}
      </StyledAlert>
    )}
    {severity === 'info' && (
      <StyledAlert variant={variant} severity="info" {...props}>
        {children}
      </StyledAlert>
    )}
    {severity === 'success' && (
      <StyledAlert
        variant={variant}
        severity="success"
        icon={<SuccessCheckmark />}
        {...props}
      >
        {children}
      </StyledAlert>
    )}
  </>
);

export default Notification;
